import React, { useState } from "react";
import {
  compose,
} from "recompose";
import {
  Page,
  withTable,
  FormGroup,
  onMount,
} from "components/common";
import { NotificationManager } from "react-notifications";
import { Trans } from "react-i18next";
import { Alert, Label, Button } from 'reactstrap';
import Select from "react-select";

export const ContactReports = ({
  error,
  contactsData,
  t
}) => {

  const pTitle = t("Aged Payables and Aged Receivables By Contact")

  const warningMessage = t('Please select a contact before generating the report.')

  function objectToArray(data) {
    if (Array.isArray(data)) {
      return data;
    } else {
      const array = Object.values(data);
      if (array.every(item => item && item.Name)) {
        return array.sort((a, b) => (a.Name > b.Name) ? 1 : -1);
      } else {
        return array;
      }
    }
  }

  const contactsList = objectToArray(contactsData);

  const [selectedContact, setSelectedContact] = useState(null);

  function getOptions() {
    if (!contactsList)
      return []
    const options = contactsList.map((contact) => {
      return { value: contact.ContactID, label: contact.Name }
    })
    return options
  }

  const handlePayablesReport = () => {
    if (!selectedContact) {
      NotificationManager.warning(warningMessage)
      return;
    }
    window.location.href = `/reports/aged_payables_by_contact/${selectedContact}`;
  };

  const handleReceivablesReport = () => {
    if (!selectedContact) {
      NotificationManager.warning(warningMessage)
      return;
    }
    window.location.href = `/reports/aged_receivables_by_contact/${selectedContact}`;
  };

  return (

    <Page
      title={pTitle} className="pb-5"
    >
      <div>
        {error && (
          <Alert color="danger">
            <Trans>{error.detail}</Trans>
          </Alert>
        )}
      </div>
      {contactsList.length === 0 && (
        <tr>
          <td colSpan="9" className="text-center">
            <span className="fa fa-spinner fa-spin mt-2" />{" "}
            <Trans>Loading...</Trans>
          </td>
        </tr>
      )}
      <div className="container-fluid my-5">
        {contactsList.length > 0 && (
          <div className="cnt row align-items-end justify-content-start">
            <div className="col-3">
              <Label><Trans>Select A Contact To View Report</Trans>:</Label>
            </div>
            <div className="col-5">
              <FormGroup>
                <Select placeholder={t('Select A Contact To View Report')} clearable={false} options={getOptions() || []} value={selectedContact} onChange={(e) => setSelectedContact(e.value)} />
              </FormGroup>
            </div>
            <div className="col-4">
              <Button color="primary" onClick={handlePayablesReport}>
                <Trans>Payable Report</Trans>
              </Button>{' '}
              <Button color="primary" onClick={handleReceivablesReport}>
                <Trans>Receivables Report</Trans>
              </Button>
            </div>
          </div>
        )}
      </div>
    </Page>
  )
};

export const enhance = compose(
  withTable({
    limit: 100,
  }),
  onMount(({ xero }) => async () => {
    const contactsData = await xero
      .get(`contacts`)
      .get("data")
      .then((contactsData) => ({
        ...contactsData,
      }));
    return {
      contactsData,
    };
  }),
);

export default enhance(ContactReports);
